export enum AppNames {
  UNITY_EXPRESS = 'EXPRESS',
  UNITY_DIRECT = 'DIRECT'
}
